import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Avatar,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardHeader from "../Dashboard/DashboardHeader";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import {
  ApplicationType,
  entity_id,
  locationGeo,
  Platform,
} from "../Utils/Const";
import { baseapi } from "../Environmentalurl";
import useIPAddress from "../Utils/useIPAddress";
import api from "../Utils/Api";

export default function TransferToBank() {
  const navigate = useNavigate();
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [transfers, setTransfers] = useState([]);
  const [user, setUser] = useState({});
  const [page, setPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [beneficiaryType, setBeneficiaryType] = useState("IFSC");
  const removeTpinRefs = useRef([]);
  const rowsPerPage = 7;
  const ip = useIPAddress();

  // ===== REMOVE BENEFICIARY STATE =====
  const [removeDialog, setRemoveDialog] = useState({
    open: false,
    beneficiary: null,
  });
  const [removeTpin, setRemoveTpin] = useState("");
  const [removeLoading, setRemoveLoading] = useState(false);
  const [removeResult, setRemoveResult] = useState({
    open: false,
    success: false,
    message: "",
  });

  const addbeneficiary = () => {
    navigate("/dashboard/transfertobank/addbeneficiary");
  };

  // ================= BENEFICIARY API =================
  const fetchBeneficiaries = async (type = beneficiaryType) => {
    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_Beneficiary",
      Statement: "GetBeneficiaries",
      Mobilenumber: sessionStorage.getItem("mobileNumber"),
      Platform: Platform,
      ApplicationType: ApplicationType,
      GeoLocation: locationGeo,
      MachineID: ip,
      EntityID: entity_id,
      SessionID: sessionStorage.getItem("SessionID"),
      BeneficiaryType: type,
      BeneficiaryID: "",
      BeneficiaryName: "",
      BeneficiaryBank: "",
      BeneficiaryAccountNumber: "",
      BeneficiaryIFSC: "",
      BeneficiaryMobileNumber: "",
      BeneficiaryMMID: "",
      TPIN: "",
      IMPS_IsVerification: "0",
    };

    try {
      const res = await api.post(
        `${baseapi}/janAadhaareWalletBeneficiary`,
        payload,
      );
      if (res.data?.Response_Code === "2710") {
        setBeneficiaries(res.data.Info || []);
      } else {
        setBeneficiaries([]);
      }
    } catch (err) {
      console.error("Beneficiary API error", err);
    }
  };

  // ================= REMOVE BENEFICIARY API =================
  const handleRemoveBeneficiary = async () => {
    if (!removeTpin) {
      alert("Please enter TPIN");
      return;
    }

    const b = removeDialog.beneficiary;

    try {
      setRemoveLoading(true);

      const payload = {
        ApplicationType: ApplicationType,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
        Mobilenumber: sessionStorage.getItem("mobileNumber"),
        Platform: Platform,
        ReqType: "Jan_Aadhaar_eWallet_Beneficiary",
        Statement: "RemoveBeneficiary",
        SessionID: sessionStorage.getItem("SessionID"),
        BeneficiaryType: beneficiaryType,
        BeneficiaryID: b.ID || "",
        BeneficiaryName: b.BeneficiaryName || "",
        BeneficiaryBank: b.BeneficiaryBank || "",
        BeneficiaryAccountNumber: b.BeneficiaryAccountNumber || "",
        BeneficiaryIFSC: b.BeneficiaryIFSC || "",
        BeneficiaryMobileNumber: b.BeneficiaryMobileNumber || "",
        BeneficiaryMMID: b.BeneficiaryMMID || "",
        TPIN: removeTpin,
        IMPS_IsVerification: "0",
      };

      const res = await api.post(
        `${baseapi}/janAadhaareWalletBeneficiary`,
        payload,
      );

      if (res.data?.Response_Code === "2690") {
        setBeneficiaries((prev) => prev.filter((item) => item.ID !== b.ID));
        setRemoveDialog({ open: false, beneficiary: null });
        setRemoveTpin("");
        setRemoveResult({
          open: true,
          success: true,
          message: res.data?.Message || "Beneficiary removed successfully",
        });
      } else {
        setRemoveDialog({ open: false, beneficiary: null });
        setRemoveTpin("");
        setRemoveResult({
          open: true,
          success: false,
          message: res.data?.Message || "Failed to remove beneficiary",
        });
      }
    } catch (err) {
      setRemoveDialog({ open: false, beneficiary: null });
      setRemoveTpin("");
      setRemoveResult({
        open: true,
        success: false,
        message: "Something went wrong. Please try again.",
      });
    } finally {
      setRemoveLoading(false);
    }
  };

  // Re-fetch whenever radio changes
  const handleBeneficiaryTypeChange = (type) => {
    setBeneficiaryType(type);
    setSearchQuery("");
    setPage(0);
    fetchBeneficiaries(type);
  };

  // ================= FILTERED BENEFICIARIES =================
  const filteredBeneficiaries = beneficiaries.filter((b) => {
    const query = searchQuery.toLowerCase().trim();
    if (!query) return true;
    if (beneficiaryType === "IFSC") {
      return (
        b.BeneficiaryName?.toLowerCase().includes(query) ||
        b.BeneficiaryAccountNumber?.toLowerCase().includes(query)
      );
    } else {
      return (
        b.BeneficiaryName?.toLowerCase().includes(query) ||
        b.BeneficiaryMobileNumber?.toLowerCase().includes(query) ||
        b.BeneficiaryMMID?.toLowerCase().includes(query)
      );
    }
  });

  useEffect(() => {
    fetchBeneficiaries("IFSC");
    fetchRecentTransactions();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const location = useLocation();

  useEffect(() => {
    const fetchBalanceEnquiry = async () => {
      try {
        const payload = {
          ApplicationType: ApplicationType,
          EntityID: entity_id,
          GeoLocation: locationGeo,
          MachineID: ip,
          Mobilenumber: sessionStorage.getItem("mobileNumber"),
          Platform: Platform,
          ReqType: "Jan_Aadhaar_eWallet_Balance_Enquiry",
          SessionID: sessionStorage.getItem("SessionID"),
        };

        const response = await api.post(
          `${baseapi}/JanAadhaareWalletBalanceEnquiry`,
          payload,
        );

        if (response.data.Response_Code === "1000") {
          setUser((prev) => ({
            ...prev,
            Balance: response.data.Balance,
            LedgerBalance: response.data.LedgerBalance,
            NameOnCard: prev.NameOnCard || "User Name",
            UPIVPA: prev.UPIVPA || "user@upi",
            Is_KYC_Done: prev.Is_KYC_Done || "1",
          }));
        } else {
          console.error("Balance Enquiry Failed:", response.data.Message);
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };

    fetchBalanceEnquiry();
  }, [location.search]);

  // ================= RECENT TRANSACTIONS API =================
  const fetchRecentTransactions = async () => {
    try {
      const payload = {
        ReqType: "Jan_Aadhaar_eWallet_Recent_Transactions",
        Mobilenumber: sessionStorage.getItem("mobileNumber"),
        ServiceID: "5",
        MachineID: ip,
        Platform: Platform,
        ApplicationType: ApplicationType,
        GeoLocation: locationGeo,
        EntityID: entity_id,
        SessionID: sessionStorage.getItem("SessionID"),
      };

      const response = await api.post(
        `${baseapi}/JanAadhaareWalletRecentTransactions`,
        payload,
      );

      if (response.data?.Response_Code === "1000") {
        setTransfers(response.data.Info || []);
      }
    } catch (error) {
      console.error("Recent Transactions API Error", error);
    }
  };

  return (
    <>
      <DashboardHeader />
      <Box bgcolor="#f7fafc" minHeight="100vh">
        <Box sx={{ maxWidth: "1200px", mx: "auto", px: 4, py: 4 }}>
          {/* HEADER */}
          <Box
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            mb={3}
            gap={2}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                sx={{ cursor: "pointer", width: "fit-content" }}
                onClick={() => navigate("/dashboard")}
              >
                <ArrowBackIosNewIcon
                  sx={{ fontSize: { xs: 16, md: 18 }, color: "#2e7d32" }}
                />
                <Typography
                  sx={{ fontSize: { xs: 16, md: 20 }, fontWeight: "bold" }}
                >
                  Transfer to Bank
                </Typography>
              </Box>
              <Typography
                sx={{ fontSize: { xs: 12, md: 14 }, color: "text.secondary" }}
              >
                Instant & secure bank transfers to any account across India.
              </Typography>
            </Box>

            <Box
              display="flex"
              flexDirection="row"
              gap={{ xs: 0.8, md: 1.5 }}
              width={{ xs: "100%", md: "30%" }}
              alignItems="center"
            >
              <Paper sx={{ p: { xs: 0.8, md: 1.5 }, borderRadius: 2, flex: 1 }}>
                <Typography sx={{ fontSize: { xs: 8, md: 10 } }}>
                  BALANCE
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: 11, md: 14 },
                    fontWeight: "bold",
                    color: "green",
                  }}
                >
                  ₹{user?.Balance}
                </Typography>
              </Paper>

              <Paper sx={{ p: { xs: 0.8, md: 1.5 }, borderRadius: 2, flex: 1 }}>
                <Typography sx={{ fontSize: { xs: 8, md: 10 } }}>
                  LIMIT
                </Typography>
                <Typography
                  sx={{ fontSize: { xs: 11, md: 14 }, fontWeight: "bold" }}
                >
                  ₹2,00,000
                </Typography>
              </Paper>

              <Button
                variant="contained"
                color="success"
                sx={{
                  borderRadius: 2,
                  height: { xs: 28, md: 36 },
                  fontSize: { xs: 10, md: 13 },
                  px: { xs: 1.5, md: 2 },
                  whiteSpace: "nowrap",
                }}
                onClick={addbeneficiary}
              >
                + Add Beneficiary
              </Button>
            </Box>
          </Box>

          {/* SAVED BENEFICIARIES */}
          <Box mb={4}>
            {/* ROW: Title | Radio Buttons | View All */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={1.5}
              flexWrap="wrap"
              gap={1}
            >
              <Typography
                fontWeight="bold"
                sx={{ fontSize: { xs: 13, md: 16 }, whiteSpace: "nowrap" }}
              >
                Send to Saved Beneficiary
              </Typography>

              {/* RADIO BUTTONS */}
              <Box display="flex" gap={3} alignItems="center">
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 500,
                  }}
                >
                  <input
                    type="radio"
                    value="IFSC"
                    checked={beneficiaryType === "IFSC"}
                    onChange={() => handleBeneficiaryTypeChange("IFSC")}
                    style={{ accentColor: "#2e7d32", width: 15, height: 15 }}
                  />
                  Account Number & IFSC
                </label>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: 500,
                  }}
                >
                  <input
                    type="radio"
                    value="MMID"
                    checked={beneficiaryType === "MMID"}
                    onChange={() => handleBeneficiaryTypeChange("MMID")}
                    style={{ accentColor: "#2e7d32", width: 15, height: 15 }}
                  />
                  MMID
                </label>
              </Box>

              <Typography
                color="success.main"
                sx={{
                  fontSize: { xs: 13, md: 16 },
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                }}
              >
                View All
              </Typography>
            </Box>

            {/* SEARCH BOX */}
            <TextField
              size="small"
              placeholder={
                beneficiaryType === "IFSC"
                  ? "Search by name or account number..."
                  : "Search by name, mobile or MMID..."
              }
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: 18, color: "#2e7d32" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                width: { xs: "100%", md: 320 },
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  fontSize: { xs: 12, md: 13 },
                  backgroundColor: "#fff",
                  "&.Mui-focused fieldset": { borderColor: "#2e7d32" },
                },
              }}
            />

            {/* BENEFICIARY CARDS */}
            <Grid container spacing={2}>
              {filteredBeneficiaries.length > 0 ? (
                filteredBeneficiaries.map((b, i) => (
                  <Grid item xs={12} md={3} key={i}>
                    <Paper
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        cursor: "pointer",
                        position: "relative",
                        "&:hover": { boxShadow: 3 },
                      }}
                      onClick={() =>
                        navigate("/dashboard/transfertobank/sendmoney", {
                          state: {
                            beneficiary: {
                              name: b.BeneficiaryName?.split("(")[0].trim(),
                              bank: b.BeneficiaryBank,
                              acc: b.BeneficiaryAccountNumber,
                              ifsc: b.BeneficiaryIFSC,
                              limit: b.UserDefinedLimit,
                              mobile: b.BeneficiaryMobileNumber,
                              mmid: b.BeneficiaryMMID,
                              type: beneficiaryType,
                            },
                          },
                        })
                      }
                    >
                      {/* ===== REMOVE (X) BUTTON ===== */}
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          setRemoveTpin("");
                          setRemoveDialog({ open: true, beneficiary: b });
                        }}
                        sx={{
                          position: "absolute",
                          top: 6,
                          right: 6,
                          color: "#ef4444",
                          bgcolor: "#fff5f5",
                          width: 22,
                          height: 22,
                          "&:hover": { bgcolor: "#fee2e2" },
                        }}
                      >
                        <CloseIcon sx={{ fontSize: 13 }} />
                      </IconButton>

                      <Box display="flex" gap={2}>
                        <Avatar sx={{ bgcolor: "#d9fbe3", color: "#2e7d32" }}>
                          {b.BeneficiaryName?.[0]}
                        </Avatar>
                        <Box>
                          <Typography fontWeight="bold" fontSize={13} pr={2}>
                            {b.BeneficiaryName?.split("(")[0].trim()}
                          </Typography>

                          {beneficiaryType === "IFSC" && (
                            <>
                              <Typography fontSize={12} color="text.secondary">
                                {b.BeneficiaryBank} •{" "}
                                {b.BeneficiaryAccountNumber}
                              </Typography>
                              <Typography fontSize={12} color="text.secondary">
                                IFSC: {b.BeneficiaryIFSC}
                              </Typography>
                            </>
                          )}

                          {beneficiaryType === "MMID" && (
                            <>
                              <Typography fontSize={12} color="text.secondary">
                                {b.BeneficiaryBank}
                              </Typography>
                              <Typography fontSize={12} color="text.secondary">
                                Mobile: {b.BeneficiaryMobileNumber}
                              </Typography>
                              <Typography fontSize={12} color="text.secondary">
                                MMID: {b.BeneficiaryMMID}
                              </Typography>
                            </>
                          )}
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "text.secondary",
                      fontSize: { xs: 12, md: 14 },
                      py: 2,
                    }}
                  >
                    {searchQuery
                      ? `No beneficiary found for "${searchQuery}"`
                      : "No beneficiaries found"}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>

          {/* RECENT TRANSFERS */}
          <Box>
            <Box display="flex" justifyContent="space-between" mb={2}>
              <Typography
                fontWeight="bold"
                sx={{ fontSize: { xs: 13, md: 16 } }}
              >
                Recent Transfers
              </Typography>
              <Typography
                color="success.main"
                sx={{ fontSize: { xs: 13, md: 16 }, cursor: "pointer" }}
              >
                View All History →
              </Typography>
            </Box>

            <TableContainer
              component={Paper}
              sx={{ borderRadius: 3, overflowX: "auto" }}
            >
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell sx={{ fontWeight: "bold" }}>Narration</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>ORDERID</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Amount</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Account Number (or) MMID
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold" }}>IFSC</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {transfers.length > 0 ? (
                    transfers
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.Narration || "-"}</TableCell>
                          <TableCell>{item.OrderID || "-"}</TableCell>
                          <TableCell
                            sx={{ color: "green", fontWeight: "bold" }}
                          >
                            ₹{item.Amount}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={item.Status}
                              color={
                                item.Status === "SUCCESS" ? "success" : "error"
                              }
                              size="small"
                            />
                          </TableCell>
                          <TableCell>{item.DetailACNUM ||item.MMID|| "-"}</TableCell>
                          <TableCell>{item.DetailIFSC || "-"}</TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No Recent Transactions Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              <TablePagination
                component="div"
                count={transfers.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[7]}
                sx={{
                  ".MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                    {
                      fontSize: { xs: 11, md: 13 },
                    },
                }}
              />
            </TableContainer>
          </Box>
        </Box>
      </Box>

      {/* ================= REMOVE BENEFICIARY DIALOG ================= */}
      <Dialog
        open={removeDialog.open}
        onClose={() => {
          setRemoveDialog({ open: false, beneficiary: null });
          setRemoveTpin("");
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
      >
        <DialogTitle sx={{ pb: 0.5 }}>
          <Typography fontWeight={700} fontSize={17}>
            Remove Beneficiary
          </Typography>
          <Typography fontSize={13} color="text.secondary">
            Are you sure you want to remove{" "}
            <strong>
              {removeDialog.beneficiary?.BeneficiaryName?.split("(")[0].trim()}
            </strong>
            ?
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ mt: 1 }}>
          {/* Beneficiary summary */}
          <Box sx={{ bgcolor: "#f5f7fb", borderRadius: 2, p: 2, mb: 2 }}>
            <Box display="flex" alignItems="center" gap={1.5}>
              <Avatar
                sx={{
                  bgcolor: "#d9fbe3",
                  color: "#2e7d32",
                  width: 36,
                  height: 36,
                }}
              >
                {removeDialog.beneficiary?.BeneficiaryName?.[0]}
              </Avatar>
              <Box>
                <Typography fontWeight={600} fontSize={14}>
                  {removeDialog.beneficiary?.BeneficiaryName?.split(
                    "(",
                  )[0].trim()}
                </Typography>
                <Typography fontSize={12} color="text.secondary">
                  {removeDialog.beneficiary?.BeneficiaryBank}
                </Typography>
                {beneficiaryType === "IFSC" && (
                  <Typography fontSize={12} color="text.secondary">
                    Acc: {removeDialog.beneficiary?.BeneficiaryAccountNumber}
                    &nbsp;|&nbsp; IFSC:{" "}
                    {removeDialog.beneficiary?.BeneficiaryIFSC}
                  </Typography>
                )}
                {beneficiaryType === "MMID" && (
                  <Typography fontSize={12} color="text.secondary">
                    Mobile: {removeDialog.beneficiary?.BeneficiaryMobileNumber}
                    &nbsp;|&nbsp; MMID:{" "}
                    {removeDialog.beneficiary?.BeneficiaryMMID}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>

          {/* TPIN input */}
          <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
            {[0, 1, 2, 3].map((index) => (
              <TextField
                key={index}
                type="password"
                value={removeTpin[index] || ""}
                inputRef={(el) => (removeTpinRefs.current[index] = el)}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(-1);

                  const arr = removeTpin.padEnd(6, " ").split("");
                  arr[index] = value;

                  setRemoveTpin(arr.join("").trim());

                  // Auto move to next box
                  if (value && index < 5) {
                    removeTpinRefs.current[index + 1]?.focus();
                  }
                }}
                onKeyDown={(e) => {
                  // Move back on Backspace
                  if (
                    e.key === "Backspace" &&
                    !removeTpin[index] &&
                    index > 0
                  ) {
                    removeTpinRefs.current[index - 1]?.focus();
                  }
                }}
                inputProps={{
                  maxLength: 1,
                  inputMode: "numeric",
                  style: {
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: 600,
                  },
                }}
                sx={{
                  width: 52,
                  "& .MuiOutlinedInput-root": {
                    height: 55,
                    borderRadius: "12px",
                  },
                }}
              />
            ))}
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => {
              setRemoveDialog({ open: false, beneficiary: null });
              setRemoveTpin("");
            }}
            sx={{ textTransform: "none", borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={!removeTpin || removeLoading}
            onClick={handleRemoveBeneficiary}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              bgcolor: "#ef4444",
              "&:hover": { bgcolor: "#dc2626" },
            }}
          >
            {removeLoading ? "Removing..." : "Remove"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ================= REMOVE RESULT POPUP ================= */}
      <Dialog
        open={removeResult.open}
        onClose={() => setRemoveResult({ ...removeResult, open: false })}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
      >
        <DialogTitle sx={{ pb: 0.5 }}>
          <Typography
            fontWeight={700}
            fontSize={17}
            color={removeResult.success ? "#16a34a" : "#dc2626"}
          >
            {removeResult.success ? "Removed Successfully" : "Remove Failed"}
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Box display="flex" alignItems="center" gap={1.5} mt={0.5}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                bgcolor: removeResult.success ? "#dcfce7" : "#fee2e2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
                flexShrink: 0,
              }}
            >
              {removeResult.success ? "✓" : "✕"}
            </Box>
            <Typography fontSize={14}>{removeResult.message}</Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => setRemoveResult({ ...removeResult, open: false })}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              bgcolor: removeResult.success ? "#22c55e" : "#ef4444",
              "&:hover": {
                bgcolor: removeResult.success ? "#16a34a" : "#dc2626",
              },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
